//This set to use Production Mode or DevelopmentMode
export const IsProdMode = false;

export const IsEncryption = true;

export const IsQueryParamsEncryption = true;


// AESKey for encryption and decryption
export const Value1 = "P1Pw0sggFsebE+Tqt+REGQ==";

// AESIV for encryption and decryption
export const Value2 = "JIeoMo1pNWQHoF92sLQqyQ==";

export const IsCookieEncryption = true;

export const WEBURL = 'https://pharma-software-front.vercel.app'

export const GoogleMapKey = "AIzaSyCT-iv_tIKc1sINLPPiPr5RTPpFTHHI1Y0";

export const Value3 = "AuthUserA111";

export const Value4 = "TokenA111";

export const IsStagingEnvironment = false;

export const Companyname = 'SANITAS HEALTHCARE';

export const APIURL = 'https://api.dashboardproject.in/api/';


